export enum WEBVIEW_TYPE {
  WELLO_APP = 'wello',
  KB_PAY = 'kbpay',
  TOSS = 'toss',
}

const KB_WEBVIEW_USER_AGENT_PATTERN = /liivmate|kbpayia/i;

export const detectWebviewType = (
  userAgent: string,
): WEBVIEW_TYPE | undefined => {
  if (userAgent.includes('welfarehello')) {
    return WEBVIEW_TYPE.WELLO_APP;
  }
  if (KB_WEBVIEW_USER_AGENT_PATTERN.test(userAgent)) {
    return WEBVIEW_TYPE.KB_PAY;
  }
  if (userAgent.includes('Toss')) {
    return WEBVIEW_TYPE.TOSS;
  }

  return undefined;
};
